import React, { useState } from 'react';
import carousel1 from '../img/carousel-1.jpg';
import carousel2 from '../img/carousel-2.jpg';
import carousel3 from '../img/carousel-3.jpg';
import carousel4 from '../img/carousel-4.jpeg';
import carousel5 from '../img/carousel-5.jpeg';
import carousel6 from '../img/carousel-6.jpeg';
import EnquiryModal from './EnquiryModal';


const slides = [
  {
    image: carousel4,
    subtitle: 'Construction Business',
    title: 'Emperia Icon',
    description:
      "Emperia Icon, located in Nerul, Navi Mumbai, is a landmark commercial project offering premium office spaces with modern architecture, state-of-the-art amenities, and excellent connectivity. It’s an ideal destination for businesses looking to establish a prestigious corporate presence.",
  },
  {
    image: carousel5,
    subtitle: 'Construction Business',
    title: 'Emperia Icon',
    description:
      "Designed for forward-thinking enterprises, Emperia Icon blends style with functionality, providing scalable workspaces in one of Navi Mumbai’s most strategic business hubs. With high ROI potential and professional-grade infrastructure, it's a smart investment for every business.",
  },
  {
    image: carousel6,
    subtitle: 'Construction Business',
    title: 'Emperia Icon',
    description:
      "Situated in the heart of Nerul, Emperia Icon offers a dynamic business environment with easy access to transport, retail, and commercial zones. Its architectural excellence and premium facilities make it a symbol of growth and success.",
  },
];


const CustomCarousel = () => {
      const [showModal, setShowModal] = useState(false);
       const [showQuoteModal, setQuoteShowModal] = useState(false);
  return (
    <div className="container-fluid overflow-hidden px-0">
      <div id="carouselId" className="carousel slide" data-bs-ride="carousel">
        <ol className="carousel-indicators">
          {slides.map((_, index) => (
            <li
              key={index}
              data-bs-target="#carouselId"
              data-bs-slide-to={index}
              className={index === 0 ? 'active' : ''}
              aria-current={index === 0 ? 'true' : undefined}
              aria-label={`Slide ${index + 1}`}
            ></li>
          ))}
        </ol>

        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              className={`carousel-item ${index === 0 ? 'active' : ''}`}
              key={index}
            >
              <img src={slide.image} className="img-fluid w-100" alt={`Slide ${index + 1}`} />
              <div className="carousel-caption">
                {/* <p
                  className="text-uppercase text-secondary fs-4 mb-0 animate__animated animate__fadeInUp"
                  style={{ animationDelay: '1s' }}
                >
                  {slide.subtitle}
                </p> */}
                <h1
                  className="display-1 text-capitalize text-white mb-4 animate__animated animate__fadeInUp"
                  style={{ animationDelay: '1.3s' }}
                >
                  {slide.title}
                </h1>
                <p
                  className="mb-5 fs-5 animate__animated animate__fadeInUp"
                  style={{ animationDelay: '1.5s' }}
                >
                  {slide.description}
                </p>
                <div className="d-flex justify-content-center">
                  <a
                    className="btn btn-primary d-flex py-3 px-5 me-2 flex-shrink-0 animate__animated animate__fadeInUp"
                    href="#"
                    style={{ animationDelay: '1.7s' }}
                     onClick={() => setQuoteShowModal(true)}
                  >
                    Get a Quotes
                  </a>
                  <a
                    className="btn btn-secondary d-inline-block py-3 px-5 ms-2 flex-shrink-0 animate__animated animate__fadeInUp"
                    href="#"
                    style={{ animationDelay: '1.7s' }}
                     onClick={() => setShowModal(true)}
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="carousel-control-prev" type="button" data-bs-target="#carouselId" data-bs-slide="prev">
          <span
            className="carousel-control-prev-icon btn-lg-square animate__animated animate__fadeInLeft"
            aria-hidden="true"
            style={{ animationDelay: '1.3s' }}
          >
            <i className="fas fa-chevron-left fa-2x"></i>
          </span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#carouselId" data-bs-slide="next">
          <span
            className="carousel-control-next-icon btn-lg-square animate__animated animate__fadeInRight"
            aria-hidden="true"
            style={{ animationDelay: '1.3s' }}
          >
            <i className="fas fa-chevron-right fa-2x"></i>
          </span>
          <span className="visually-hidden">Next</span>
        </button>

        <EnquiryModal show={showModal} onClose={() => setShowModal(false)} formtitle={" Contact Us"} />
         <EnquiryModal show={showQuoteModal} onClose={() => setQuoteShowModal(false)} formtitle={" Get a Quote"} />
      </div>
    </div>
  );
};

export default CustomCarousel;
